import { render } from "./SignatureBlock.vue?vue&type=template&id=919a066a&scoped=true"
import script from "./SignatureBlock.vue?vue&type=script&lang=js"
export * from "./SignatureBlock.vue?vue&type=script&lang=js"

import "./SignatureBlock.vue?vue&type=style&index=0&id=919a066a&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-919a066a"]])

export default __exports__